// התחלה: פונקציה שמחזירה Templates של לוחות

import { SimulationChangeType } from "../interfaces/DTO/simulation";
import { IReorderable, UserTask, UserTaskList, UserTaskOrigin } from "../interfaces/DTO/userTask/UserTask";

export interface BoardTemplate {
    name: string;
    description?: string;
    lists: {
      name: string;
      color?: string;
    }[];
  }
  export function getCardColorOptions(): { label: string; value: string }[] {
    return [
      { label: "אפור", value: "#9e9e9e" },
      { label: "אדום", value: "#f44336" },
      { label: "כתום", value: "#ff9800" },
      { label: "צהוב", value: "#ffeb3b" },
      { label: "ירוק", value: "#4caf50" },
      { label: "כחול", value: "#2196f3" },
      { label: "סגול", value: "#673ab7" },
    ];
  }
  
  export function getBoardTemplates(): BoardTemplate[] {
    return [
      {
        name: "לוח ריק",
        description: "לוח ללא רשימות מראש",
        lists: [],
      },
      {
        name: "לוח קלאסי",
        description: "To Do / In Progress / Done",
        lists: [
          { name: "To Do", color: "#f44336" },
          { name: "In Progress", color: "#ff9800" },
          { name: "Done", color: "#4caf50" },
        ],
      },
      {
        name: "פיתוח תוכנה",
        description: "Backlog / Development / QA / Deployed",
        lists: [
          { name: "Backlog", color: "#9e9e9e" },
          { name: "Development", color: "#2196f3" },
          { name: "QA", color: "#673ab7" },
          { name: "Deployed", color: "#4caf50" },
        ],
      },
    ];
  }

  export function sortTasks(tasks: UserTask[]): UserTask[] {
    return [...tasks].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  export function sortLists(lists: UserTaskList[]): UserTaskList[] {
    return [...lists].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  export function reorder<T extends IReorderable>(
    items: T[],
    fromIndex: number,
    toIndex: number
  ): T[] {
    const result = Array.from(items);
    const [moved] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, moved);
  
    return result.map((item, index) => ({
      ...item,
      order: index,
    }));
  }

  export function formatTaskOrigin(origin?: UserTaskOrigin): string {
    switch (origin) {
      case UserTaskOrigin.SIMULATION:
        return "מתוך סימולציה";
      case UserTaskOrigin.MANUAL:
        return "משימה ידנית";
      case UserTaskOrigin.SYSTEM:
        return "נוצרה על ידי המערכת";
      case UserTaskOrigin.EXTERNAL:
        return "נוצרה ממערכת חיצונית";
      default:
        return "לא ידוע";
    }
  }
  export function colorSimulationChangeType(changeType?: SimulationChangeType): string {
  switch (changeType) {
    case SimulationChangeType.CHANGE_FUND:
      return "#0077CC"; // כחול
    case SimulationChangeType.CHANGE_FEE:
      return "#00B894"; // ירוק בהיר
    case SimulationChangeType.CLOSE_AND_MOVE:
      return "#6C5CE7"; // סגול
    case SimulationChangeType.PARTIAL_TRANSFER:
      return "#A29BFE"; // סגול בהיר
    case SimulationChangeType.OPEN_NEW:
      return "#D63031"; // אדום
    case SimulationChangeType.DEPOSIT:
      return "#FDC00E"; // כתום
    case SimulationChangeType.WITHDRAWAL:
      return "#E17055"; // כתום כהה
    case SimulationChangeType.UNCHANGED:
      return "#B2BEC3"; // אפור
    case SimulationChangeType.NEW_RECURRENT_DEPOSIT:
      return "#17a2b8"; // תכלת
    case SimulationChangeType.CHANGE_RECURRENT_DEPOSIT:
      return "#20c997"; // ירוק-תכלת
    case SimulationChangeType.STOP_RECURRENT_DEPOSIT:
      return "#E17055"; // כתום כהה
    case SimulationChangeType.INSURANCE_HANDLER_CHANGE:
      return "#6C5CE7"; // סגול - ניוד יצרן
    case SimulationChangeType.INSURANCE_COVERAGE_INCREASE:
      return "#00B894"; // ירוק - הגדלת כיסוי
    case SimulationChangeType.BENEFICIARY_UPDATE:
      return "#8d6e63"; // חום - עדכון מוטבים
    case SimulationChangeType.VIEW_POWER_OF_ATTORNEY:
      return "#5c6bc0"; // אינדיגו - ייפוי כוח לצפייה
    default:
      return "#636E72"; // ברירת מחדל
  }
}

  export function formatSimulationChangeType (changeType?: SimulationChangeType): string  {
    switch (changeType) {
      case SimulationChangeType.CHANGE_FUND:
        return "שינוי מסלול";
      case SimulationChangeType.CHANGE_FEE:
        return "הורדת דמי ניהול";
      case SimulationChangeType.CLOSE_AND_MOVE:
        return "ניוד מלא";
      case SimulationChangeType.PARTIAL_TRANSFER:
        return "ניוד חלקי";
      case SimulationChangeType.OPEN_NEW:
        return "פתיחת פוליסה חדשה";
      case SimulationChangeType.DEPOSIT:
        return "הפקדה";
      case SimulationChangeType.WITHDRAWAL:
        return "משיכה";
      case SimulationChangeType.UNCHANGED:
        return "אין שינוי";
      case SimulationChangeType.NEW_RECURRENT_DEPOSIT:
        return "הוראת קבע חדשה";
      case SimulationChangeType.CHANGE_RECURRENT_DEPOSIT:
        return "שינוי הוראת קבע";
      case SimulationChangeType.STOP_RECURRENT_DEPOSIT:
        return "הפסקת הוראת קבע";
      case SimulationChangeType.INSURANCE_HANDLER_CHANGE:
        return "ניוד מלא לגמל";
      case SimulationChangeType.INSURANCE_COVERAGE_INCREASE:
        return "הגדלת סכום כיסוי";
      case SimulationChangeType.BENEFICIARY_UPDATE:
        return "עדכון מוטבים";
      case SimulationChangeType.VIEW_POWER_OF_ATTORNEY:
        return "ייפוי כוח לצפייה";
      default:
        return "לא ידוע";
    }
  };
  

  
  